module.exports = __webpack_public_path__ + "img/p2-44.9a041a40.png";